// Public surface of the charges feature (Instance B, collections / charge rules sprint).
//
// The registry imports the default (the Charges page: needs a person, visits without
// a charge) and `chargesIcon`. Other screens mount, one line each:
//
//   import { ChargeTemplatesCard, CopyLastChargeButton } from '../features/charges';
//   <ChargeTemplatesCard practiceId={id} isAdmin={isAdmin} />
//   <CopyLastChargeButton practiceId={practiceId} claim={claim} onCopied={reload} />
//
// Both gate themselves on `features.charge_templates`.

import React from "react";

export { default } from "./ChargesPage";
export { default as ChargesPage } from "./ChargesPage";
export { default as ChargeTemplatesCard } from "./ChargeTemplatesCard";
export { default as CopyLastChargeButton } from "./CopyLastChargeButton";

export const feature = "charge_templates";

export const chargesIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <path d="M14 2v6h6" />
    <path d="M12 18v-6" />
    <path d="M9 15h6" />
  </svg>
);
